import React from 'react'
import { SettingsFormValues } from 'src/Elements/SystemSettings/Battery/types'
import { FarmBatteryModel } from 'src/Libs/batteries'

import BatterySettingsData from 'src/Elements/SystemSettings/Battery/BatterySettingsData'

interface Props {
  model: FarmBatteryModel
  batteryId: string
  onUpdate: (storageSerialNo: string, values: SettingsFormValues, batteryId: string) => Promise<boolean | null>
  isReadOnlyAccess?: boolean
}

/**
 * Component to display and manage the settings of a storage battery.
 * It wraps the BatterySettingsData component and provides the necessary props for updating the battery settings.
 */
const StorageBatterySettingsData: React.FC<Props> = ({ model, batteryId, onUpdate, isReadOnlyAccess }) => (
  <BatterySettingsData model={model} isReadOnlyAccess={isReadOnlyAccess} onUpdate={values => onUpdate(model.storageSerialNo, values, batteryId)} />
)

export default StorageBatterySettingsData
